<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input placeholder="Nome/Id/RG/CPF/Inscrição/DataDeNascimento"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <b-field>
                    <b-input placeholder="Referência"
                            v-model="referencia"
                            icon="magnify"
                            @input="loadAsyncData"></b-input>
                </b-field>   
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input placeholder="Código"
                                v-model="id"
                                type="number"
                                icon-right="edit"
                                icon-right-clickable
                                @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 aria-next-label="Próxima página"
                 aria-previous-label="Página anterior"
                 aria-page-label="Página"
                 aria-current-label="Página atual"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template slot-scope="props" @click="abrirCadastro(props.row.id)">
                <b-table-column field="Id" label="Código" sortable :class="verificaGuiaSelecionada(props.row.id)">
                    {{ props.row.id }}
                    <br><small title="Referência">{{ props.row.referencia }}</small>
                </b-table-column>

                <b-table-column field="PacienteNome" label="Paciente" sortable :class="verificaGuiaSelecionada(props.row.id)">
                    {{ props.row.pacienteNome }}
                </b-table-column>

                <b-table-column field="ConvenioNome" label="Convênio" sortable :class="verificaGuiaSelecionada(props.row.id)">
                    {{ props.row.convenioNome }}
                </b-table-column>

                <b-table-column field="MedicoNome" label="Médico" sortable :class="verificaGuiaSelecionada(props.row.id)">
                    {{ props.row.medicoNome }}
                </b-table-column>

                <b-table-column field="LocalDeOrigemNome" label="Local de Origem" sortable :class="verificaGuiaSelecionada(props.row.id)">
                    {{ props.row.localDeOrigemNome }}
                </b-table-column>

                <b-table-column field="DataDeEmissao" label="Emissão" sortable :class="verificaGuiaSelecionada(props.row.id)">
                    {{ $moment(props.row.dataDeEmissao).format("DD/MM/YYYY HH:mm") }}
                </b-table-column>

                <b-table-column custom-key="actions" numeric :class="verificaGuiaSelecionada(props.row.id)">
                    <router-link :to="{ name: 'guia', params: { id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import titlebar from '@/components/titlebar.vue'
    import debounce from 'lodash/debounce'
    import { mapState, mapGetters } from 'vuex'

    export default {
        data(){
            return {
                model: [],
                total: 0,
                loading: false,
                pacienteId: this.$route.query.pacienteId,
                medicoId: this.$route.query.medicoId,
                guiaId: this.$route.query.guiaId,
                convenioId: this.$route.query.convenioId,
                procurar: this.$route.query.procurar ?? '',
                referencia: this.$route.params.referencia ?? '',
                amostra: this.$route.params.amostra ?? '',
                ordenarPor: 'DataUltimaModificacao',
                ordenar: 'desc',
                defaultOrdenar: 'desc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    'Atendimento',
                    'Guias'
                ]
            },
            ...mapState([
                'unidadeId'
            ])
        },
        methods: {
            verificaGuiaSelecionada(id) {
                return this.guiaId == id
                    ? "has-background-warning"
                    : null
            },
            loadAsyncData: debounce(function () {
                const params = [
                    `nome=${this.procurar}`,
                    `referencia=${this.referencia}`,
                    `unidadeId=${this.unidadeId}`,
                    `amostra=${this.amostra}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`
                ];

                if (this.pacienteId != null) 
                    params.push(`pacienteId=${this.pacienteId}`);
                if (this.medicoId != null) 
                    params.push(`medicoId=${this.medicoId}`);
                if (this.convenioId != null) 
                    params.push(`convenioId=${this.convenioId}`);

                this.loading = true
                this.$http.get(`/api/atendimento/procurar?${params.join('&')}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }})
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            }, 500),
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {
                this.$router.push({ path: `/atendimento/guia/${this.selecionado.id}` })
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/atendimento/guia/${this.id}` })
            }
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>